import type { GuidebookProperty } from "./types"

interface Props {
  property: GuidebookProperty
}

export function PropertyInfoSection({ property }: Props) {
  const items: Array<{ icon: React.ReactNode; label: string; text: string }> = []

  if (property.parking_instruction) {
    items.push({ icon: <ParkingIcon />, label: "Parking", text: property.parking_instruction })
  }
  if (property.trash_instruction) {
    items.push({ icon: <TrashIcon />, label: "Waste & recycling", text: property.trash_instruction })
  }
  if (property.supermarket_hint) {
    items.push({ icon: <ShopIcon />, label: "Nearest shop", text: property.supermarket_hint })
  }

  if (!property.region_description && items.length === 0) return null

  return (
    <div className="gb-section">
      <h2 className="gb-section__title">About the area</h2>
      {property.region_description && (
        <p className="gb-info__description">{property.region_description}</p>
      )}
      {items.length > 0 && (
        <div className="gb-info__items">
          {items.map((item, i) => (
            <div className="gb-info__item" key={i}>
              <span className="gb-info__item-icon">{item.icon}</span>
              <div>
                <span className="gb-info__item-label">{item.label}: </span>
                {item.text}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

function ParkingIcon() {
  return (
    <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <rect x="2" y="2" width="14" height="14" rx="2" />
      <path d="M7 13V5h3a3 3 0 0 1 0 6H7" />
    </svg>
  )
}

function TrashIcon() {
  return (
    <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M3 5h12M7 5V3h4v2M5 5l1 10h6l1-10" />
    </svg>
  )
}

function ShopIcon() {
  return (
    <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
      <path d="M2 7l2-4h10l2 4M2 7v8a1 1 0 001 1h12a1 1 0 001-1V7" />
      <path d="M7 16v-5h4v5" />
    </svg>
  )
}
